import { createAsyncThunk } from "@reduxjs/toolkit";
import productsService from "../../../api/services/products";

export const getProducts = createAsyncThunk(
  "products/get-products",
  async (requestData) => {
    return await productsService.getProducts(requestData);
  }
);

export const getProductsSearch = createAsyncThunk(
  "products/get-products-search",
  async (requestData) => {
    return await productsService.getProducts(requestData);
  }
);

export const getProduct = createAsyncThunk(
  "products/get-product",
  async (id) => {
    return await productsService.getProduct(id);
  }
);

export const getCategories = createAsyncThunk(
  "products/get-categories",
  async () => {
    return await productsService.getCategories();
  }
);

export const getProductsByCategory = createAsyncThunk(
  "products/get-products-by-category",
  async (requestData) => {
    return await productsService.getProductsByCategory(requestData);
  }
);

export const createCategory = createAsyncThunk(
  "products/create-category",
  async (requestData) => {
    return await productsService.createCategory(requestData);
  }
);

export const deleteCategory = createAsyncThunk(
  "products/delete-category",
  async (id) => {
    return await productsService.deleteCategory(id);
  }
);

export const createProduct = createAsyncThunk(
  "products/create-product",
  async (requestData) => {
    const formData = new FormData();

    formData.append("thumbnail", requestData.thumbnail);

    requestData.images.forEach((img, idx) => {
      formData.append("images", img);
    });

    formData.append("name", requestData.name);
    formData.append("description", requestData.description);
    formData.append("price", requestData.price);
    if (requestData.salePrice) {
      formData.append("salePrice", requestData.salePrice);
    }
    formData.append("color", requestData.color);
    formData.append("colorString", requestData.colorString);
    if (requestData.badge) {
      formData.append("badge", requestData.badge);
    }
    formData.append("stockS", requestData.stockS ?? 0);
    formData.append("stockM", requestData.stockM ?? 0);
    formData.append("stockL", requestData.stockL ?? 0);
    formData.append("stockXL", requestData.stockXL ?? 0);
    formData.append("stockSM", requestData.stockSM ?? 0);
    formData.append("stockLXL", requestData.stockLXL ?? 0);
    formData.append("stockSocksS", requestData.stockSocksS ?? 0);
    formData.append("stockSocksM", requestData.stockSocksM ?? 0);
    formData.append("category", requestData.category);
    formData.append("comingSoon", requestData.comingSoon ? "true" : "false");

    return await productsService.createProduct(formData);
  }
);

export const editProduct = createAsyncThunk(
  "products/edit-product",
  async ({
    id,
    name,
    description,
    price,
    salePrice,
    color,
    colorString,
    badge,
    stockS,
    stockM,
    stockL,
    stockXL,
    stockSM,
    stockLXL,
    stockSocksS,
    stockSocksM,
    category,
    comingSoon,
    thumbnailFile,
    imagesFiles,
  }) => {
    const formData = new FormData();
    formData.append("name", name);
    formData.append("description", description);
    formData.append("price", price ?? "");
    if (salePrice) {
      formData.append("salePrice", salePrice);
    }
    formData.append("color", color);
    formData.append("colorString", colorString);
    if (badge) {
      formData.append("badge", badge);
    }
    formData.append("stockS", stockS ?? 0);
    formData.append("stockM", stockM ?? 0);
    formData.append("stockL", stockL ?? 0);
    formData.append("stockXL", stockXL ?? 0);
    formData.append("stockSM", stockSM ?? 0);
    formData.append("stockLXL", stockLXL ?? 0);
    formData.append("stockSocksS", stockSocksS ?? 0);
    formData.append("stockSocksM", stockSocksM ?? 0);
    formData.append("category", category);
    formData.append("comingSoon", comingSoon ? "true" : "false");

    if (thumbnailFile) {
      formData.append("thumbnail", thumbnailFile);
    }
    if (imagesFiles && imagesFiles.length) {
      imagesFiles.forEach((img) => formData.append("images", img));
    }

    return await productsService.editProduct(id, formData);
  }
);

export const deleteProduct = createAsyncThunk(
  "products/delete-product",
  async (id) => {
    return await productsService.deleteProduct(id);
  }
);
